import { render, staticRenderFns } from "./Fretboard.vue?vue&type=template&id=71162283&scoped=true"
import script from "./Fretboard.vue?vue&type=script&lang=js"
export * from "./Fretboard.vue?vue&type=script&lang=js"
import style0 from "./Fretboard.vue?vue&type=style&index=0&id=71162283&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71162283",
  null
  
)

export default component.exports